export const ACTIVATION_PENDING_STAGES = {
  INITIAL: 'initial',
  RESCHEDULE_SERVICE_ORDER: 'booking_form',
  RESCHEDULE_ACTIVATION_CONFIRMATION: 'reschedule_confirmation',
  SCHEDULING_SUCCESS: 'schedule_success',
}
